import { useState } from "react";
import { Modal } from "./ui";

export function normalizeWa(phone) {
  if (!phone) return "";
  let p = String(phone).replace(/[^\d+]/g, "").replace(/^\+/, "");
  if (p.startsWith("00")) p = p.slice(2);
  if (!p.startsWith("39") && p.length <= 11) p = "39" + p;
  return p;
}

const TEMPLATES = [
  { label: "Nessun messaggio (chat vuota)", text: "" },
  { label: "Saluto", text: "Buongiorno {nome}, le scrivo da SC Dottori Commercialisti Srl Stp (Studio Silvia Casali)." },
  { label: "Conferma appuntamento", text: "Buongiorno {nome}, le confermo l'appuntamento. A presto!" },
  { label: "Richiamo cliente", text: "Buongiorno {nome}, la contatto in merito a {azienda}. Quando possiamo sentirci?" },
];

export function WhatsAppButton({ phone, name, company, className = "btn sm", label = "WhatsApp", icon = false }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  if (!phone) return null;

  const first = (name || "").split(" ")[0];
  const fill = (t) => (t || "").replace(/\{nome\}/g, first).replace(/\{azienda\}/g, company || "");
  const openChat = () => {
    const num = normalizeWa(phone);
    if (!num) return;
    const url = `https://wa.me/${num}` + (text ? `?text=${encodeURIComponent(text)}` : "");
    window.open(url, "_blank", "noopener");
    setOpen(false);
  };

  return (
    <>
      <button className={className + " wa-fluo"}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setText(""); setOpen(true); }}
        title="Scrivi su WhatsApp" data-testid="whatsapp-btn">
        {icon ? "WA" : label}
      </button>
      {open && (
        <Modal title="Scrivi su WhatsApp" onClose={() => setOpen(false)}>
          <p className="muted" style={{ marginTop: 0 }}>A: {name || phone} · {normalizeWa(phone)}</p>
          <div className="field"><label>Messaggio predefinito</label>
            <select onChange={(e) => setText(fill(TEMPLATES[Number(e.target.value)].text))} data-testid="wa-template">
              {TEMPLATES.map((t, i) => <option key={i} value={i}>{t.label}</option>)}
            </select>
          </div>
          <div className="field"><label>Testo (modificabile)</label>
            <textarea rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi un messaggio (facoltativo)…" data-testid="wa-text" />
          </div>
          <p className="muted" style={{ fontSize: 12 }}>Si aprirà WhatsApp con la chat già pronta: il messaggio lo invii tu manualmente. Nessun invio automatico.</p>
          <div className="modal-actions">
            <button className="btn" onClick={() => setOpen(false)}>Annulla</button>
            <button className="btn primary" onClick={openChat} data-testid="wa-open">Apri WhatsApp</button>
          </div>
        </Modal>
      )}
    </>
  );
}
